<template>
    <div v-if="calculatedResult">
        <div class="row">
            <div class="col-sm-6">
                <h4 class="text-center" v-if="result.request.ashp.heatingFuel == 2">
                    You could save {{ calculatedResult.savings | currency(0) }} annually by adding Air-Source Heat
                    Pump to your home
                </h4>

                <h4 class="text-center" v-else>
                    You could reduce your carbon footprint by {{ calculatedResult.co2Emission | number(1) }} tonnes
                    annually by adopting an Air-Source Heat Pump
                </h4>

                <img class="img-responsive" src="../../../assets/results-page/ashp.png" />
            </div>

            <div class="col-sm-6">
                <div class="card _margin-top-30 _margin-bottom-20">
                    <div class="detail-card _margin-bottom-30">
                        <div class="detail-card-title">
                            Your Details
                        </div>

                        <table class="table" style="margin-bottom: -5px;">
                            <tbody>
                                <tr>
                                    <td><span class="glyphicon glyphicon-map-marker"></span> {{ address.text }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="pull-left" style="margin-top: 4px">
                                            <span class="glyphicon glyphicon-home"></span>
                                            {{ result.request.address.propertyType }}
                                        </div>

                                        <button type="button" class="btn btn-ghost btn-xs pull-right" @click="onEdit">
                                            Change
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="glyphicon glyphicon-fire"></span>
                                        {{ heatingTypeList | findProp('id', 'label', result.request.ashp.heatingFuel) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h6 class="_margin-bottom-0">Annual energy cost with an Air-Source Heat Pump</h6>
                    <h4 class="_margin-top-0">{{ calculatedResult.annualCost | currency(0) }}</h4>

                    <h6 class="_margin-bottom-0">Recommended heat pump size</h6>
                    <h4 class="_margin-top-0">{{ result.request.ashp.ashpSize }} kWh</h4>

                    <h6 class="_margin-bottom-0">Recommended energy tariff</h6>
                    <div class="recommend-tariff">
                        <div class="logo">
                            <supplier-logo :id="calculatedResult.supplierId" />
                        </div>

                        <h4>
                            {{ calculatedResult.tariffName }}
                        </h4>
                    </div>
                </div>

                <p style="font-size: 14px;" class="_margin-bottom-0">
                    We have calculated your Carbon Reduction and Annual Energy Costs with an Air-Source Heat Pump based
                    on the following:
                </p>

                <ul class="_margin-bottom-0" style="padding-left: 20px;">
                    <li v-if="result.request.ashp.heatingFuel == 1">
                        We used an average gas consumption for your chosen property type, adjusted seasonally and
                        broken down into a daily usage pattern, which we then converted to a half-hourly electricity
                        usage pattern.
                    </li>

                    <li v-if="result.request.ashp.heatingFuel == 1">
                        Based on the conversion, we determined how much electricity would be needed to achieve the
                        same level of heating with an air-source heat pump at your property.
                    </li>

                    <li v-if="result.request.ashp.heatingFuel == 2">
                        In the absence of specific data on your current electricity use for heating, we used a
                        formula based on OFGEM's Typical Domestic Consumption Values (TDCV). This helps estimate the
                        portion of your electricity that likely goes towards heating, hot water, and some cooking.
                    </li>

                    <li v-if="result.request.ashp.heatingFuel == 2">
                        Using this estimate, we calculated how much electricity would be needed to maintain the same
                        heating level with an air-source heat pump at your property.
                    </li>

                    <li v-if="result.request.ashp.heatingFuel == 3">
                        In the absence of specific information on your current oil consumption for heating, we used
                        OFGEM's electricity-to-gas ratios to estimate your likely heating needs in gas based on your
                        indicated electricity use. We then converted this estimated energy consumption into the amount
                        of heat produced to approximate oil consumption.
                    </li>

                    <li v-if="result.request.ashp.heatingFuel == 3">
                        Using the estimated energy, we calculated how much electricity would be needed to achieve the
                        same level of heating with an air-source heat pump at your property.
                    </li>

                    <li>
                        The best published Time of Use (ToU) tariff currently available in the market at the time of
                        generating this quote.
                    </li>
                </ul>
            </div>
        </div>

        <p style="max-width: none">
            Installation costs for an air-source heat pump will depend on many factors, so it is not possible to provide
            a general quote for installation and supply. There may also be government incentives available to help
            reduce the cost of installation
        </p>

        <!-- <div class="row _margin-top-20 _margin-bottom-20">
            <div class="col-xs-12">
                <uiv-btn type="ghost" block @click="showSummary = !showSummary">
                    Detailed Breakdown <span class="glyphicon glyphicon-chevron-right" v-if="!showSummary"></span>
                    <span class="glyphicon glyphicon-chevron-down" v-if="showSummary"></span>
                </uiv-btn>
            </div>
        </div> -->

        <uiv-collapse v-model="showSummary">
            <div class="row">
                <div class="col-md-12">
                    <h5>In our calculations, we made the following assumptions:</h5>
                    <ul style="padding-left: 20px;">
                        <li>
                            We allow for hot water heating over 3 hours, to provide hot
                            water at 7:00 am each day
                        </li>
                        <li>Heating target temperature for the house is 20&deg;C</li>
                        <li>Flow temperatures used:</li>
                        <li style=" list-style: none;">
                            <ul style="padding-left: 12px; list-style-type: disc;">
                                <li>35&deg;C for space heating</li>
                                <li>50&deg;C for hot water</li>
                                <li>60&deg;C for Legionella cycle once a week</li>
                            </ul>
                        </li>
                        <li>For Electricity-only heating, you are heating during the period of midnight-7:00 am</li>
                    </ul>

                    <h5 class="_margin-top-30">Energy consumption changes</h5>
                    <div class="card _margin-bottom-20">

                    </div>

                    <h5>Energy consumption changes</h5>
                    <div class="card _margin-bottom-20">

                    </div>

                    <h5>Your expected system details (20 years)</h5>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="card _margin-bottom-20">

                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card _margin-bottom-20">
                                <small>
                                    <p class="_margin-top-0 _margin-bottom-0">
                                        Annual cost of electricity used by ASHP (£)
                                    </p>
                                </small>
                                <h4 class="_margin-top-0 _margin-bottom-0">
                                    £??
                                </h4>
                            </div>

                            <div class="card">
                                <small>
                                    <p class="_margin-top-0 _margin-bottom-0">
                                        Total electricity used by ASHP in one year
                                        (kWh) :
                                    </p>
                                </small>
                                <h4 class="_margin-top-0 _margin-bottom-20">
                                    ??kWh
                                </h4>

                                <small>
                                    <p class="_margin-top-0 _margin-bottom-0">
                                        For heating :
                                    </p>
                                </small>
                                <h4 class="_margin-top-0 _margin-bottom-0">
                                    ??kWh
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </uiv-collapse>

        <uiv-modal v-model="openEditModal" title="Choose Property">
            <div class="row _margin-bottom-30">
                <div class="col-xs-6" v-for="p in propertyList" :key="p.name">
                    <radio-button v-model="form.propertyId" :value="p.id" class="radio-icons">
                        <img v-if="p.id == 3" src="../../../assets/Terraced_House.svg" class="center-block" />
                        <img v-else-if="p.id == 4" src="../../../assets/Semi-detached_House.svg" class="center-block" />
                        <img v-else-if="p.id == 5" src="../../../assets/Bungalow.svg" class="center-block" />
                        <img v-else-if="p.id == 7" src="../../../assets/Apartments.svg"
                            class="center-block img-responsive" />
                        <img v-else src="../../../assets/Detached_House.svg" class="center-block" />
                        {{ p.name }}
                    </radio-button>
                </div>
            </div>

            <!-- <h6 class="_margin-bottom-20">How much time in the day is someone at home?</h6>
            <div class="col-xs-6 col-md-3" v-for="item in houseUsageList">
                <radio-button v-model="form.propertyUsage" :value="item.id">{{ item.label }}</radio-button>
            </div> -->

            <div slot="footer">
                <uiv-btn @click="openEditModal = false">Cancel</uiv-btn>

                <uiv-btn type="primary" @click="onUpdateDetails">Update</uiv-btn>
            </div>
        </uiv-modal>

        <uiv-modal v-model="openEquireModal" size="md" title="Enquire Now" :footer="!submittedEnquire">
            <div v-if="!submittedEnquire">
                <h5>Your pathway to home decarbonisation!</h5>
                <p>
                    Share a few details, and we'll connect you with our expert installer base, helping you to a greener,
                    more carbon-efficient home.
                </p>

                <h6>Contact Information</h6>
                <div class="row _margin-bottom-20">
                    <div class="col-xs-12">
                        <label for="fullName">Full Name</label>
                        <validation-messages label="Full Name" :$v="$v.enquireForm.fullName">
                            <form-field id="fullName" type="text" v-model="enquireForm.fullName"
                                :error="$v.enquireForm.fullName.$error" />
                        </validation-messages>
                    </div>
                </div>

                <div class="row _margin-bottom-20">
                    <div class="col-xs-12">
                        <label for="email">Email</label>
                        <validation-messages label="Email" :$v="$v.enquireForm.email">
                            <form-field id="email" type="text" v-model="enquireForm.email"
                                :error="$v.enquireForm.email.$error" />
                        </validation-messages>
                    </div>
                </div>

                <div class="row _margin-bottom-20">
                    <div class="col-xs-12">
                        <label for="phone">Phone</label>
                        <validation-messages label="Phone" :$v="$v.enquireForm.phone">
                            <form-field id="phone" type="text" v-model="enquireForm.phone"
                                :error="$v.enquireForm.phone.$error" maxlength="11" minlength="10"
                                @blur="$v.enquireForm.phone.$touch()" />
                        </validation-messages>
                    </div>
                </div>

                <div class="row _margin-bottom-20">
                    <div class="col-xs-12">
                        <label for="contactTime">When is the best time to contact you?</label>
                        <validation-messages label="Best time to contact" :$v="$v.enquireForm.contactTime">
                            <select-list id="contactTime" v-model="enquireForm.contactTime"
                                :list="[{ label: 'AM', value: 'AM' }, { label: 'PM - Afternoon', value: 'PM - Afternoon' }, { label: 'PM - Evening', value: 'PM - Evening' }]"
                                :error="$v.enquireForm.contactTime.$error" />
                        </validation-messages>
                    </div>
                </div>

                <div class="row _margin-bottom-20" v-if="quoteSession.solar || quoteSession.ashp">
                    <div class="col-xs-12">
                        <label>Your Property</label>
                        <div>{{ result.request.address.propertyType }}</div>
                    </div>
                </div>

                <label>Are you considering adopting asset(s) this year?</label>
                <div class="row _margin-bottom-20">
                    <div class="col-xs-4">
                        <radio-button v-model="enquireForm.adoptAsset" value="'yes'"
                            :error="$v.enquireForm.adoptAsset.$error">Yes</radio-button>
                    </div>
                    <div class="col-xs-4">
                        <radio-button v-model="enquireForm.adoptAsset" value="'no'"
                            :error="$v.enquireForm.adoptAsset.$error">No</radio-button>
                    </div>
                    <div class="col-xs-4">
                        <radio-button v-model="enquireForm.adoptAsset" value="'unsure'"
                            :error="$v.enquireForm.adoptAsset.$error">Unsure</radio-button>
                    </div>
                </div>

                <div class="row _margin-bottom-20">
                    <div class="col-xs-12">
                        <label for="info">Please provide any additional information</label>
                        <textarea id="info" class="form-control" v-model="enquireForm.additionalInfo"></textarea>
                    </div>
                </div>

                <div class="row  _margin-bottom-10">
                    <div class="col-xs-12">
                        <small>
                            <b>Privacy Notice</b><br />
                            Information collected through this form will be used for the sole purpose for processing
                            your enquiry, connecting you with our services.
                            We will share the information you provide with our trusted partners or affiliates who assist
                            us in fulfilling your request.
                        </small>
                    </div>
                </div>
            </div>

            <div class="text-center" v-else>
                <div class="tick-container">
                    <div class="tick"></div>
                </div>

                <h4 class="_margin-bottom-0">Thank you!</h4>
                <p class="_margin-top-0">
                    Your enquiry has been submitted
                </p>
            </div>

            <div slot="footer">
                <div class="row">
                    <div class="col-xs-6">
                        <uiv-btn size="sm" block @click="openEquireModal = false">
                            Close
                        </uiv-btn>
                    </div>
                    <div class="col-xs-6">
                        <uiv-btn type="primary" size="sm" block @click="onEnquire">
                            Enquire
                        </uiv-btn>
                    </div>
                </div>
            </div>
        </uiv-modal>
    </div>
    <div v-else>
        <div class="alert alert-info _margin-top-30">
            No result found
        </div>
    </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import CheckboxButton from '../../../../base/components/forms/CheckboxButton';
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

import { mapState } from 'vuex';
import { required, alpha, helpers, numeric, maxLength, minLength } from 'vuelidate/lib/validators';

import SystemPerformanceChart from './SystemPerformanceChart';
import CumulativeSavingsChart from './CumulativeSavingsChart';
import AnnualSavingsChart from './AnnualSavingsChart';

export default {
    name: 'AirSourceHeatPumpResults',
    data() {
        return {
            submittedEnquire: false,
            showSummary: false,
            openEditModal: false,
            openEquireModal: false,
            form: {
                propertyId: null,
                propertyUsage: null
            },
            enquireForm: {
                asset: 'ASHP',
                fullName: null,
                email: null,
                phone: null,
                contactTime: null,
                additionalInfo: null,
                adoptAsset: null
            }
        };
    },
    mounted() {
        if (this.quoteSession.ashp) {
            this.$store.dispatch('lookups/getInsulationList');
            this.$store.dispatch('lookups/getHeatingTypeList');
        }
    },
    validations: {
        form: {
            propertyId: { required },
            propertyUsage: { required }
        },
        enquireForm: {
            fullName: { required },
            email: {
                required,
                regex: helpers.regex('email', /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)
            },
            phone: {
                required,
                numeric,
                maxLength: maxLength(11),
                minLength: minLength(10),
                regex: helpers.regex('phone', /^(?=.*\d)(?=.*[1-9]).{1,11}$/)
            },
            contactTime: { required },
            adoptAsset: { required }
        }
    },
    computed: {
        ...mapState({
            quote: ({ quote }) => quote,
            address: ({ session }) => session.quote.address,
            quoteSession: ({ session }) => session.quote_journey_session,
            result: ({ quote_results }) => quote_results.result,
            propertyList: ({ lookups }) => lookups.esaPropertyTypes,
            houseUsageList: ({ lookups }) => lookups.houseUsageTypes,
            calculatedResult: ({ quote_results }) => quote_results.result.calculatedResults.find(({ isCurrent }) => {
                return isCurrent == false;
            }) || {},
            heatingTypeList: ({ lookups }) => lookups.heatingTypes
        })
    },
    methods: {
        onEdit() {
            this.form.propertyId = this.result.request.address.propertyTypeId;
            this.openEditModal = true;
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Change' });
            this.$store.dispatch('tracing/saveActions');
        },
        async onUpdateDetails() {
            await this.$store.dispatch('quote/editQuote', {
                propertyTypeId: this.form.propertyId
            });
            await this.$store.dispatch('quote_results/getQuoteResults');
            this.openEditModal = false;
            const propertyType = this.propertyList.find(({ id }) => id == this.form.propertyId);

            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Updated' });
            this.$store.dispatch('tracing/addAction', { name: 'Value', value: propertyType.name });
            this.$store.dispatch('tracing/saveActions');
        },
        onArrangeCall() {
            this.openEquireModal = true;
        },
        async onEnquire() {
            this.$v.enquireForm.$touch();
            if (this.$v.enquireForm.$invalid) return;
            await this.$store.dispatch('quote_results/enquire', this.enquireForm);
            this.submittedEnquire = true;
        },
        convertToPositive(number) {
            return number < 0 ? -1 * number : number;
        }
    },
    components: {
        SupplierLogo,
        RadioButton,
        CheckboxButton,
        SystemPerformanceChart,
        CumulativeSavingsChart,
        AnnualSavingsChart
    }
};

</script>

<style lang="scss" scoped>
.detail-card {
    padding: 0 15px 15px 15px;
    border-radius: 10px;
    border: 1px solid #dadada;

    .detail-card-title {
        font-size: 16px;
        padding: 13px 15px;
        margin: 0 -15px 10px -15px;
        border-bottom: 1px solid #dadada;
        font-weight: bold;

        .btn {
            position: relative;
            top: -3px;
        }
    }
}

.img-responsive {
    @media (max-width:767px) {
        max-width: 70%;
        margin: auto;
    }
}

.recommend-tariff {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;

    h4 {
        padding-left: 15px;
        margin: 0;
    }
}
</style>
